import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
/* import { WagmiProvider } from 'wagmi';
import { RainbowKitProvider, darkTheme } from '@rainbow-me/rainbowkit';
import { config } from './hooks/config'; */
import { store } from './app/store';
import App from './App';
import './index.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
/* import '@rainbow-me/rainbowkit/styles.css'; */

const queryClient = new QueryClient();

const root = createRoot(document.getElementById('root'));
const persistor = persistStore(store);

root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <QueryClientProvider client={queryClient}>
        {/* <WagmiProvider config={config}>
          <RainbowKitProvider theme={darkTheme()}> */}
            <Router>
              <App />
            </Router>
          {/* </RainbowKitProvider>
        </WagmiProvider> */}
      </QueryClientProvider>
    </PersistGate>
  </Provider>
);